<template>
  <div class="d-inline-block">
    <a
      v-if="isLogged"
      href="#"
      @click.prevent="logOut()"
    >
      {{ $t('buttons.logout') }}
    </a>
    <router-link
      v-else
      :to="{ name: 'login' }"
      class="ml-3"
    >
      {{ $t('menu.login') }}
    </router-link>
  </div>
</template>

<script>
export default {
    name: 'AppLogout',
    computed: {
        isLogged () {
            return this.$store.getters.getIsLoggedIn;
        }
    },
    methods: {
        logOut () {
            this.$store.dispatch('logout').then(() => {
                this.$router.push({ name: 'login' });
            });
        }
    }
};
</script>

<style scoped></style>
